const tippy = require('tippy.js');
const imageClient = require('@bluekiri/alexandria-contrib-components/components/image/client/js');
const { elementExist } = require('../../../../helpers/domHelpers');
/**
 * Client/browser JS for a product card
 * @param {string} selector jQuery selector
 */
module.exports = function ProductCardCruisesClient(selector = '[data-component="ProductCardCruises"]') {
    if (elementExist(selector)) {
        tippy(`${selector} [data-type="icon"]`, {
            arrow: true,
            arrowType: 'sharp',
            duration: 0,
            placement: 'bottom',
            theme: 'translucent base-dark highlights'
        });

        imageClient(`${selector} [data-component="Image"][data-type="logo"]`);
        imageClient(`${selector} [data-component="Image"][data-type="summary"]`);
        imageClient(`${selector} [data-component="Image"][data-type="itinerary"]`);

        const elements = document.querySelectorAll(`${selector}`);

        elements.forEach(item => {
            const elementNav = item.querySelector('[data-type="nav-tab"]');
            const elementImage = item.querySelectorAll('[data-type="image"]');
            const elementContent = item.querySelectorAll('[data-type="content"]');

            elementNav.addEventListener('click', event => {
                const { target } = event;

                if (!target.classList.contains('isActive')) {
                    elementNav.querySelector('.isActive').classList.remove('isActive');
                    target.classList.add('isActive');
                    elementImage.forEach(elem => elem.classList.toggle('isActive'));
                    elementContent.forEach(elem => elem.classList.toggle('isActive'));
                }
            });
        });
    }
};
